export { LearnFlashcardActionArea } from "#learn-card-action-area";
